import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isNavScrolled, setIsNavScrolled] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsNavScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsServicesOpen(false);
    setIsMobileMenuOpen(false);
  }, [location]);

  const services = [
    { name: '水塔清洗', path: '/services/water-tank' },
    { name: '水管水刀疏通', path: '/services/pipe-cleaning' },
    { name: '水溝清洗', path: '/services/drain-cleaning' },
    { name: '內視鏡檢查', path: '/services/endoscope' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isNavScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/c61c43d626627dd077148c0c867066d5/cfe71aaae57fe1c5116ea6f3c5e00c1e.jpeg" 
              alt="永業環保 Logo" 
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="flex items-center gap-3">
              <h1 className="text-2xl font-bold text-[#1e3a5f]">永業環保</h1>
              <span className="hidden md:block text-sm text-gray-500 font-light">專業管道清潔專家</span>
            </div>
          </Link>
          
          <div className="hidden lg:flex items-center gap-8">
            <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm whitespace-nowrap">首頁</Link>
            <span className="w-1 h-1 bg-[#1e3a5f] rounded-full"></span>
            
            <div 
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm whitespace-nowrap flex items-center gap-1">
                服務項目
                <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>
              
              {isServicesOpen && (
                <div className="absolute top-full left-0 pt-2 min-w-[180px]">
                  <div className="bg-white rounded-lg shadow-lg py-2">
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.path}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1e3a5f] transition-colors whitespace-nowrap"
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            <span className="w-1 h-1 bg-[#1e3a5f] rounded-full"></span>
            <Link to="/cases" className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm whitespace-nowrap">施工案例</Link>
            <span className="w-1 h-1 bg-[#1e3a5f] rounded-full"></span>
            <Link to="/about" className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm whitespace-nowrap">關於我們</Link>
            <span className="w-1 h-1 bg-[#1e3a5f] rounded-full"></span>
            <Link to="/contact" className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm whitespace-nowrap">聯絡我們</Link>
          </div>

          <div className="flex items-center gap-4">
            <Link to="/contact" className="bg-[#1e3a5f] text-white px-4 md:px-6 py-2.5 rounded-full text-xs md:text-sm font-medium hover:bg-[#2d5a8f] transition-colors flex items-center gap-2 whitespace-nowrap">
              <i className="ri-phone-line"></i>
              <span className="hidden sm:inline">立即預約</span>
              <span className="sm:hidden">預約</span>
            </Link>

            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-[#1e3a5f] transition-colors"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col gap-4">
              <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm">首頁</Link>
              
              <div>
                <button 
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                  className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm flex items-center gap-1 w-full"
                >
                  服務項目
                  <i className={`ri-arrow-down-s-line transition-transform duration-300 ${isServicesOpen ? 'rotate-180' : ''}`}></i>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${isServicesOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="ml-4 mt-2 flex flex-col gap-2">
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.path}
                        className="text-gray-600 hover:text-[#1e3a5f] transition-colors text-sm"
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              
              <Link to="/cases" className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm">施工案例</Link>
              <Link to="/about" className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm">關於我們</Link>
              <Link to="/contact" className="text-gray-700 hover:text-[#1e3a5f] transition-colors text-sm">聯絡我們</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}